module.exports = __webpack_public_path__ + "img/kommune-1566.e6a4fce1.svg";